import React from 'react';
import GroupLightComponent from './configs/LightGroupConfig';

const LazerPagina = () => {
  return (
    <div className="lazer-container">
      <GroupLightComponent
        groupIds={[
          "grupo40","grupo41","grupo42","grupo43","grupo44","grupo45","grupo46","grupo47","grupo48",
          "grupo49","grupo50","grupo51","grupo52","grupo53","grupo54","grupo55","grupo56"
        ]}
        pageId="2"
      />
    </div>
  );
};

export default LazerPagina;